import { Divider, Typography } from '@mui/material';
import theme from 'assets';
import palette from 'assets/palette';

interface IDetailsPageHeader {
    sectionName: string
    children: React.ReactNode
}

let DetailsPageHeader = ({ sectionName, children }: IDetailsPageHeader) => {

    return (
        <>
            <Typography variant='h4' style={{ color: palette.option1.main }}>{sectionName}</Typography>
            <Divider orientation='horizontal' style={{ width: '100%', marginTop: theme.spacing(0.5), marginBottom: theme.spacing(1) }} />
            {children}
            <div style={{ marginBottom: 16 }} />
        </>
    );
}

export default DetailsPageHeader;